// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/restrict/app/css/app.css
// module id = 826
// module chunks = 0